import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Divi",
    description: "The Divi logo system: a heavy, forward-leaning red wordmark with a monogram, neon outline and knockout badge, all built for dark backgrounds.",
    url: getOrigin()
}
